import {ApiKeyASchema} from '@cohort/admin-schemas/apiKeys';
import {
  EmailSchema,
  HexColorSchema,
  LanguageSchema,
  LocalizedRichTextSchema,
  LocalizedStringSchema,
  WebappLanguageSchema,
} from '@cohort/shared/schema/common';
import {z} from 'zod';

export const MembershipPassConfigurationASchema = z.object({
  title: LocalizedStringSchema,
  bannerFileKey: z
    .string({required_error: 'Banner is required', invalid_type_error: 'Banner is required'})
    .nullable(),
  backgroundColorCode: HexColorSchema.nullable(),
});
export type MembershipPassConfigurationADto = z.infer<typeof MembershipPassConfigurationASchema>;

export const MerchantASchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  name: z.string().min(3),
  slug: z.string().min(3),
  logoFileKey: z.string().nullable(),
  description: LocalizedRichTextSchema,
  backgroundColorCode: HexColorSchema.nullable(),
  accentColorCode: HexColorSchema.nullable(),
  supportEmail: EmailSchema.nullable(),
  membershipPassConfiguration: MembershipPassConfigurationASchema,
  defaultLanguage: WebappLanguageSchema,
  supportedLanguages: z.array(LanguageSchema),
  emailSigninEnabled: z.boolean(),
  spaceUrl: z.string().url(),
});
export type MerchantADto = z.infer<typeof MerchantASchema>;

export const CreateMerchantASchema = z.object({
  name: z.string().min(3),
  defaultLanguage: WebappLanguageSchema,
  supportedLanguages: z.array(LanguageSchema).optional(),
  logoFileKey: z.string().nullable().optional(),
  description: LocalizedRichTextSchema.optional(),
  backgroundColorCode: HexColorSchema.nullable().optional(),
  accentColorCode: HexColorSchema.nullable().optional(),
  embedUrl: z.string().url().nullable().optional(),
  redirectLoginUrl: z.string().url().nullable().optional(),
  supportEmail: EmailSchema.nullable().optional(),
  emailSigninEnabled: z.boolean().optional(),
});
export type CreateMerchantADto = z.infer<typeof CreateMerchantASchema>;

export const PatchMerchantASchema = CreateMerchantASchema.extend({
  membershipPassConfiguration: MembershipPassConfigurationASchema.partial().optional(),
})
  .partial({
    name: true,
  })
  .omit({
    defaultLanguage: true,
  });

export type PatchMerchantADto = z.infer<typeof PatchMerchantASchema>;

export const MerchantNameAvailabilityASchema = z.object({
  available: z.boolean(),
});
export type MerchantNameAvailabilityADto = z.infer<typeof MerchantNameAvailabilityASchema>;

// GetMerchantApiSettings
export const GetMerchantApiSettingsResponseASchema = z.object({
  embedUrl: z.string().url().nullable(),
  redirectLoginUrl: z.string().url().nullable(),
  webhooksPortalLink: z.string().url(),
  apiKeys: z.array(ApiKeyASchema),
});
export type GetMerchantApiSettingsResponseADto = z.infer<
  typeof GetMerchantApiSettingsResponseASchema
>;
